import { jsx as _jsx } from "react/jsx-runtime";
import translate from '../../../translate';
export const Title = ({ title }) => {
    // TODO: remove the old style for AH26. 
    const isOldStyle = true; // Temporary variable to easily switch between styles during the AH26 transition period then will be removed once the new style is fully adopted and the old one deleted
    const newStyle = "w-full text-black text-center text-[93px] font-normal leading-none tracking-wider";
    const oldStyle = "font-heading text-[4.5rem] font-semibold text-center leading-none uppercase";
    const className = isOldStyle ? oldStyle : newStyle;
    return (_jsx("div", { children: _jsx("p", { className: className, style: isOldStyle ? {} : { fontFamily: '"SezaneLogotype"' }, children: title || translate('front.popin.title') }) }));
};
